let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j02A7")).then(() => parcelRequire('l4FfF'));